import { defineComponent as n, computed as r, openBlock as c, createBlock as p, unref as s } from "vue";
import a from "../assets/icons/chevron-right.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "chevron-right-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, o = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, i = r(() => o[l.size]);
    return (t, d) => (c(), p(s(a), {
      fill: t.fill,
      width: i.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=chevron-right-icon.vue.mjs.map
